import React from 'react'
import Typewriter from "typewriter-effect";
import './Blog.scss'

const Blog = () => {
  return (
    <div className="flex flex-col justify-center items-center blog min-h-screen">
      <div
        data-aos="zoom-in"
        className="animate-charcter"
      >
        <Typewriter
          options={{
            strings: ["BLOG COMING SOON ........."],
            autoStart: true,
            loop: true,
          }}
        />
      </div>
    </div>
  );
}

export default Blog